import { LoginError } from './reducer/loginReducer';
import { FormattedMessage } from 'react-intl';
import { contactLink } from '../common/ContactLink';
import { Typography } from '@mui/material';
import { FunctionBuilder } from '../../../common/src';

export const LoginErrorMessage = (props: { errorCode: LoginError }) => {
  return (
    <Typography variant='body2' color={'error'}>
      <FunctionBuilder>
        {() => {
          switch (props.errorCode) {
            case 'bad-credentials':
            case 'expired':
              return <FormattedMessage id={'signup.error.invalid-token'} />;
            case 'rate-limited':
              return <FormattedMessage id={'auth.otp.resend.limit-exceeded'} />;
            case 'generic-error':
              return (
                <FormattedMessage
                  id={'common.error.generic.rich'}
                  values={{ contactLink }}
                />
              );
            case 'local-user-not-found':
              return <></>;
          }
        }}
      </FunctionBuilder>
    </Typography>
  );
};
